import axios from 'axios'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { getCarBrand, AddCarBrand, getCountries, getSingleCarBrandDetail, UpdateCarBrand } from '../../../actions/homeAction'

const CarModelAdd = () => {
  const [dataEdit, setDataEdit] = useState(false)
  const [carModel, setCarModel] = useState({
      name:"",
      nameAr:"",
      countryId:"",
      priority:0,
      area:'',
      status: true
  })

  const [image, setImage] = useState({})
  const [mediaID, setMediaID] = useState('')
  const [allCountries, setAllCountries] = useState([])
  
  console.log('dataEdit', dataEdit);
  
  
  const dispatch = useDispatch()

	// const {cmUUID} = useParams()
	const param = useParams()
  
  const location = window.location.href.split('/')[6]

	useEffect(() => {
		dispatch(getCountries())
    // if(location === 'Update'){
    //   dispatch(getSingleCarBrandDetail(cmUUID))
    //   setDataEdit(true)
    // } else {
    //   setDataEdit(false)
    // }
    dispatch(getCarBrand())
	},[])

	const countries = useSelector(state => state.home.countriesList)?.response
  const carBrand = useSelector(state => state.home.CarBrandList)
  const singleData = useSelector(state => state.home.singleBrandDetail)?.response?.[0]
  

  const handleCountryClick = (countryId) => {
    setAllCountries((prevSelectedCountryIds) => {
      if (prevSelectedCountryIds?.includes?.(countryId)) {
        // Country ID is already selected, so remove it from the array
        return prevSelectedCountryIds.filter((id) => id !== countryId);
      } else {
        // Country ID is not selected, so add it to the array
        return [...prevSelectedCountryIds, countryId];
      }
    });
  };

  useEffect(()=>{
    if(param?.cmUUID){
      var fill = carBrand?.response?.filter(item=>item.brandId===param?.cmUUID)
      setDataEdit(fill[0])
      console.log("FIL",fill);
    }
  },[param?.cmUUID])

  const onChangeHandle = (e) => {
    const {name, value} = e.target
    setCarModel({...carModel, [name]:value})
  }

  useEffect(() => {
    if(dataEdit){
      setCarModel({
          name: dataEdit?.name,
          nameAr: dataEdit?.nameAr,
          countryId: dataEdit?.countryId,
          // allCountries: singleData?.allCountries?.map(dt => dt?.brandCountryId),
          priority: dataEdit?.priority,
          area: dataEdit?.area,
          active: dataEdit?.status,
          logo: dataEdit?.logo,
      })
      setAllCountries(dataEdit?.allCountries?.map(dt => dt?.countryId))
      setImage(dataEdit?.media.path)
    }
  },[dataEdit])
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('loged_In_auth'),
    },
  };

  const uploadMedia = (e) => {
    console.log("media", e.target.files[0]);
    const file = e.target.files[0]

    const reader = new FileReader(file)
    reader.readAsDataURL(file);
    // console.log("result", reader);
    if(file !== undefined){
      reader.onloadend = () => {
          setImage({
            mimeType: reader.result
          })
          console.log("result", image);
      }
    }
    let data = new FormData()

    data.append('media', file)
    console.log("datadata", data);

    axios
      .post('https://caravenue.infoware.xyz/api/media/new', data, config)

      .then(res => {
        console.log("responsehtisis", res.data.response.media[0]?.mediaId);
        setImage(res.data.response.media[0])
        setMediaID(res.data.response.media[0]?.mediaId)
      })
      .catch(err => {
        console.log(err);
      })
  }

  const onSave = () => {
    if(dataEdit){
        const payload = {
          name:carModel.name,
          nameAr:carModel.nameAr,
          area:carModel.area,
          allCountries,
          // countryId:carModel.countryId,
          logo:image?.mediaID,
          priority:Number(carModel.priority),
          status:carModel.status === 'false' ? false : true,
          media:image,
          brandId: dataEdit?.brandId
        }
        dispatch(UpdateCarBrand(payload))
    } else {
        const payload = {
          name:carModel.name,
          nameAr:carModel.nameAr,
          area:carModel.area,
          allCountries,
          // countryId:carModel.countryId,
          logo:mediaID,
          priority:Number(carModel.priority),
          status:carModel.status === 'false' ? false : true,
          media:image
        }
        console.log("78payload0", payload);
        dispatch(AddCarBrand(payload))
    }
  }

  return (
    <div className='main-body'>
      <div className='page-wrapper'>
        <div className='page-header'>
          <div className='row align-items-end'>
            <div className='col-lg-8'>
              <div className='page-header-title'>
                <div className='d-inline'>
                  <h4>
                    { dataEdit ? `Edit : ${dataEdit?.name}` : "Add Car Brand"  } 
                  </h4>
                </div>
              </div>
            </div>
                  <div className='col-lg-4'>
                    <div className='page-header-breadcrumb'>
                      <ul className='breadcrumb-title'>
                        <li className='breadcrumb-item'>
                          <Link to='/'>
                            <i className='feather icon-home'></i>{' '}
                          </Link>
                        </li>
                        <li className='breadcrumb-item'>
                          <Link to='/CarDetail/CarModel'>Car Brand</Link>
                        </li>
                        <li className='breadcrumb-item active'>
                        { dataEdit ? "Edit Car Brand:" : "Add Car Brand" } 
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className='page-body'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <div className='card card-border-default'>
                      <div className='card-block'>
                        
                        <div className='tab-content tabs'>
                          <div
                            className='tab-pane  active'
                            id={'car_user_'}
                            role='tabpanel'
                            aria-labelledby=''>
                              <div className=''>
                  
                        <div className='card-body'>
                          <div className='row'>
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Car Brand</label>
                                <div className='col-sm-9'>
                                  <input
                                    type='text'
                                    className='form-control'
                                    name='name'
                                    value={carModel.name}
                                    placeholder='Car Brand Name'
                                    onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Car Brand Ar</label>
                                <div className='col-sm-9'>
                                  <input
                                    type='text'
                                    className='form-control'
                                    name='nameAr'
                                    value={carModel.nameAr}
                                    placeholder='Car Brand Name Ar'
                                    onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Country</label>
                                <div className='col-sm-9' style={{display:'flex', gap:'1rem', flexWrap:'wrap', alignItems:'center'}}>
                                    {
                                      countries?.map((con, ind) => <div key={ind} value={con.countryId} style={{display:'flex', gap:'0.4rem', alignItems:'center',height:'fit-content'}}>
                                        <input type="checkbox" name="" id={con?.countryId} onChange={() => handleCountryClick(con.countryId)} checked={allCountries?.includes?.(con.countryId)}/>
                                        <label style={{margin:'0', padding:'0'}} htmlFor={con?.countryId}>{con.name}</label>
                                      </div>)
                                    }
                                  {/* <select name="countryId" onChange={onChangeHandle} className='form-control' value={carModel.countryId} id="">
                                    <option value="">Select Country</option>
                                    {
                                      countries?.map(con => <option key={con.countryId} value={con.countryId}>{con.name}</option>)
                                    }
                                  </select> */}
                                </div>
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Area</label>
                                <div className='col-sm-9'>
                                  <input type="text" placeholder='Area' name='area' className='form-control' value={carModel.area} onChange={onChangeHandle}/>
                                </div>
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Priority</label>
                                <div className='col-sm-9'>
                                  <input
                                    type='number'
                                    className='form-control'
                                    name='priority'
                                    value={carModel.priority}
                                    placeholder='Priority'
                                    onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
                           
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Status</label>
                                <div className='col-sm-9'>
                                  <select
                                    name='status'
                                    className='form-control'
                                    onChange={onChangeHandle}
                                    value={carModel?.status}
                                    >
                                    <option value={true} name='active'> 
                                      Active
                                    </option>
                                    <option value={false} name='inactive'> 
                                      Inactive
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className='col-md-6'>
                            <div className='row'>
                              <div className='col-sm-3'> Image</div>
                              <div className='col-sm-9'>
                                <form
                                  id='userImage'
                                  name='userImage'
                                  encType='multipart/form-data'
                                  className='text-capitalize'>
                                  <div className='form-group'>
                                    <input
                                      accept='image/*'
                                      onChange={uploadMedia}
                                      id='banner_image'
                                      type='file'
                                      className='form-control'
                                      autoComplete='off'
                                      name='media'
                                      data-toggle='tooltip'
                                      title='Click To Upload Photo'
                                    />
                                    <div id='banner_image_lable' className='pt-2'>
                                      
                                          <img
                                            // src={this.state.image}
                                            alt=''
                                            className='img-100'
                                            onError={e => {
                                              e.target.src = '';
                                            }}
                                          />
                                        
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                            </div>
                          </div>
                        <div className='card-footer'>
                          <div className='row float-right p-3'>
                            <button
                              onClick={onSave}
                              className='btn btn-grd-disabled mr-2'>
                              <i className='icofont icofont-save'></i> {dataEdit ? 'Update' : 'Save'}
                            </button>
                            <Link to={'/CarDetail/CarBrand'} className='btn btn-outline-dark'>
                              {' '}
                              Cancel{' '}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default CarModelAdd